import { FC } from 'react';
import { ChipModel } from './Chip';
import FilterChipsBar from './FilterChipsBar';
import { TransferReservationBaseFiltersFormType } from 'app/viaje/viajeTraslado/viajeTraslado/components/ViajeTrasladoBaseFilters';
import {
  formatCountLabel,
  getClientTypeLabel,
  getServiceTypeLabel
} from 'shared/helpers';
import { useClientNames, useDriverNames } from 'shared/hooks';
interface ChipsBarProps {
  filters: TransferReservationBaseFiltersFormType;
  defaultFilters?: TransferReservationBaseFiltersFormType;
  onFiltersChange: (filters: TransferReservationBaseFiltersFormType) => void;
}
const ChipsBar: FC<ChipsBarProps> = ({ filters, defaultFilters, onFiltersChange }) => {
  const { getClientName } = useClientNames();
  const { getDriverName } = useDriverNames();
  const chips: ChipModel[] = [];
  if (filters.dateFrom && filters.dateFrom.format('DD/MM/YYYY HH:mm') !== defaultFilters?.dateFrom?.format('DD/MM/YYYY HH:mm')) {
    chips.push({
      label: 'Desde:',
      value: `${filters.dateFrom.format('DD/MM/YYYY HH:mm')}`,
      onDelete: () => onFiltersChange({ ...filters, dateFrom: null })
    });
  }

  if (filters.dateTo && filters.dateTo.format('DD/MM/YYYY HH:mm') !== defaultFilters?.dateTo?.format('DD/MM/YYYY HH:mm')) {
    chips.push({
      label: 'Hasta:',
      value: `${filters.dateTo.format('DD/MM/YYYY HH:mm')}`,
      onDelete: () => onFiltersChange({ ...filters, dateTo: null })
    });
  }

  if (filters.client_type && filters.client_type !== 'AllClient') {
    chips.push({
      label: 'Tipo de Cliente:',
      value: getClientTypeLabel(filters.client_type),
      onDelete: () => onFiltersChange({ ...filters, client_type: 'AllClient' })
    });
  }
  if (filters.clientId) {
    chips.push({
      label: 'Cliente:',
      value: getClientName(filters.clientId, filters.client_type),
      onDelete: () => onFiltersChange({ ...filters, clientId: null })
    });
  }

  if (filters.serviceType && filters.serviceType !== 'Todos') {
    chips.push({
      label: 'Servicio:',
      value: getServiceTypeLabel(filters.serviceType),
      onDelete: () => onFiltersChange({ ...filters, serviceType: 'Todos' })
    });
  }

  if (filters.bus_type_id && filters.bus_type_id.length > 0) {
    chips.push({
      label: 'Tipos de Bus:',
      value: formatCountLabel(filters.bus_type_id.length),
      onDelete: () => onFiltersChange({ ...filters, bus_type_id: [] })
    });
  }

  if (filters.street) {
    chips.push({
      label: 'Calle:',
      value: filters.street,
      onDelete: () => onFiltersChange({ ...filters, street: '' })
    });
  }

  if (filters.locality) {
    chips.push({
      label: 'Localidad:',
      value: filters.locality,
      onDelete: () => onFiltersChange({ ...filters, locality: '' })
    });
  }

  if (filters.reservationId) {
    chips.push({
      label: 'Reserva ID:',
      value: filters.reservationId,
      onDelete: () => onFiltersChange({ ...filters, reservationId: '' })
    });
  }

  if (filters.client_phone) {
    chips.push({
      label: 'Teléfono Cliente:',
      value: filters.client_phone,
      onDelete: () => onFiltersChange({ ...filters, client_phone: '' })
    });
  }

  if (filters.hasPriority) {
    chips.push({
      label: 'Filtro:',
      value: 'Prioritario',
      onDelete: () => onFiltersChange({ ...filters, hasPriority: false })
    });
  }

  if (filters.has_platform_id) {
    chips.push({
      label: 'Filtro:',
      value: 'Sol. Plataforma',
      onDelete: () => onFiltersChange({ ...filters, has_platform_id: false })
    });
  }

  if (filters.is_llt_pais) {
    chips.push({
      label: 'Filtro:',
      value: 'LLT-Pais',
      onDelete: () => onFiltersChange({ ...filters, is_llt_pais: false })
    });
  }

  if (filters.from_app) {
    chips.push({
      label: 'Filtro:',
      value: 'Desde App',
      onDelete: () => onFiltersChange({ ...filters, from_app: false })
    });
  }

  if (filters.is_event) {
    chips.push({
      label: 'Filtro:',
      value: 'Evento',
      onDelete: () => onFiltersChange({ ...filters, is_event: false })
    });
  }

  if (filters.event_name) {
    chips.push({
      label: 'Nombre del Evento:',
      value: filters.event_name,
      onDelete: () => onFiltersChange({ ...filters, event_name: '' })
    });
  }

  if (filters.sent_reservations_platform) {
    chips.push({
      label: 'Cargado en plataforma:',
      value: 'Sí',
      onDelete: () =>
        onFiltersChange({
          ...filters,
          sent_reservations_platform: false
        })
    });
  }

  if (filters.not_sent_reservations_platform) {
    chips.push({
      label: 'Cargado en plataforma:',
      value: 'No',
      onDelete: () =>
        onFiltersChange({
          ...filters,
          not_sent_reservations_platform: false
        })
    });
  }

  if (filters.authorized_id) {
    chips.push({
      label: 'Autorizado ID:',
      value: filters.authorized_id.toString(),
      onDelete: () => onFiltersChange({ ...filters, authorized_id: null })
    });
  }

  if (filters.cost_center) {
    chips.push({
      label: 'Centro de Costos:',
      value: filters.cost_center,
      onDelete: () => onFiltersChange({ ...filters, cost_center: '' })
    });
  }

  if (filters.sub_cost_center) {
    chips.push({
      label: 'Sub Centro de Costos:',
      value: filters.sub_cost_center,
      onDelete: () => onFiltersChange({ ...filters, sub_cost_center: '' })
    });
  }

  if (filters.sector) {
    chips.push({
      label: 'Sector:',
      value: filters.sector,
      onDelete: () => onFiltersChange({ ...filters, sector: '' })
    });
  }

  if (filters.buy_order) {
    chips.push({
      label: 'Orden de Compra:',
      value: filters.buy_order,
      onDelete: () => onFiltersChange({ ...filters, buy_order: '' })
    });
  }

  if (filters.plataformaId) {
    chips.push({
      label: 'ID Plataforma:',
      value: filters.plataformaId,
      onDelete: () => onFiltersChange({ ...filters, plataformaId: '' })
    });
  }

  if (filters.state && filters.state !== 'Todos') {
    chips.push({
      label: 'Estado:',
      value: filters.state,
      onDelete: () => onFiltersChange({ ...filters, state: 'Todos' })
    });
  }

  if (filters.passangerName) {
    chips.push({
      label: 'Pasajero:',
      value: filters.passangerName,
      onDelete: () => onFiltersChange({ ...filters, passangerName: '' })
    });
  }

  if (filters.phone) {
    chips.push({
      label: 'Teléfono Pasajero:',
      value: filters.phone,
      onDelete: () => onFiltersChange({ ...filters, phone: '' })
    });
  }

  if (filters.pre_assigned_driver_id) {
    chips.push({
      label: 'Chofer Pre-asignado:',
      value: getDriverName(filters.pre_assigned_driver_id),
      onDelete: () =>
        onFiltersChange({ ...filters, pre_assigned_driver_id: null })
    });
  }

  if (filters.assigned_driver_id) {
    chips.push({
      label: 'Chofer Asignado:',
      value: getDriverName(filters.assigned_driver_id),
      onDelete: () => onFiltersChange({ ...filters, assigned_driver_id: null })
    });
  }

  if (filters.business_unit) {
    chips.push({
      label: 'Unidad de Negocio:',
      value: filters.business_unit.toString(),
      onDelete: () => onFiltersChange({ ...filters, business_unit: undefined })
    });
  }

  if (filters.driver_with_close_shift) {
    chips.push({
      label: 'Filtro:',
      value: 'Chofer con turno cerrado',
      onDelete: () =>
        onFiltersChange({
          ...filters,
          driver_with_close_shift: false
        })
    });
  }

  if (filters.departure_time_exceeded) {
    chips.push({
      label: 'Filtro:',
      value: 'Horario de salida superado',
      onDelete: () =>
        onFiltersChange({
          ...filters,
          departure_time_exceeded: false
        })
    });
  }

  if (filters.color) {
    chips.push({
      label: 'Color:',
      value: (
        <span
          style={{
            display: 'inline-block',
            width: 12,
            height: 12,
            borderRadius: '50%',
            backgroundColor: filters.color,
            flexShrink: 0
          }}
        />
      ),
      onDelete: () => onFiltersChange({ ...filters, color: undefined })
    });
  }

  return <FilterChipsBar chips={chips} />;
};

export default ChipsBar;
